import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";

const MOUNTAIN_MARK = "/mountain-mark.png";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[var(--bg)] border-t hairline mt-32"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Link to="/" data-testid="footer-logo-link" className="inline-block mb-5" aria-label="Summit Scents — Home">
            <img
              src={MOUNTAIN_MARK}
              alt="Summit Scents mountain mark"
              className="h-6 md:h-7 w-auto select-none"
              draggable={false}
            />
          </Link>
          <p className="text-sm text-[var(--secondary-text)] max-w-md leading-relaxed">
            A brand started for your benefits. We believe every man deserves a chance at perfection, which is what every Summit customer receives. Join Summit Scents and start your fragrance journey today.
          </p>
        </div>

        <div>
          <h4 className="text-[10px] uppercase tracking-label text-[var(--gold)] mb-4">
            Explore
          </h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/ivory" className="text-[var(--primary-text)]/70 hover:text-[var(--gold)] transition" data-testid="footer-ivory-link">No. 1 — Ivory</Link></li>
            <li><Link to="/shop" className="text-[var(--primary-text)]/70 hover:text-[var(--gold)] transition" data-testid="footer-shop-link">Shop</Link></li>
            <li><Link to="/about" className="text-[var(--primary-text)]/70 hover:text-[var(--gold)] transition" data-testid="footer-about-link">About Summit</Link></li>
            <li><Link to="/contact" className="text-[var(--primary-text)]/70 hover:text-[var(--gold)] transition" data-testid="footer-contact-link">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[10px] uppercase tracking-label text-[var(--gold)] mb-4">
            Follow
          </h4>
          <div className="flex items-center gap-4">
            <a
              href="https://instagram.com/summit.scents"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="text-[var(--primary-text)]/70 hover:text-[var(--gold)] transition"
              aria-label="Summit Scents on Instagram"
            >
              <Instagram size={18} strokeWidth={1.2} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t hairline">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[10px] uppercase tracking-label text-[var(--secondary-text)]">
            © 2026 Summit Scents — All Rights Reserved
          </p>
          <p className="text-[10px] uppercase tracking-label text-[var(--secondary-text)]">
            
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
